import React, {useEffect} from 'react';
import {ActionModal, useErrorHandler, ErrorModal} from '../../../../shared';
import {Text} from '@gravity-ui/uikit';
import {BenefactorModel, useLockUsers} from '../../../../entities';

interface BanBenefactorModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  benefactor: BenefactorModel;
}

export const BanBenefactorModal = ({open, setOpen, benefactor}: BanBenefactorModalProps) => {
  const {lockUserMutation, unlockUserMutation} = useLockUsers({userId: benefactor.id, setOpen});

  const {
    isErrorModalOpen,
    errorInfo,
    handleError,
    handleClose
  } = useErrorHandler({
    resourceName: 'Блокировка пользователя',
  });

  useEffect(() => {
    if (lockUserMutation.error) {
      handleError(lockUserMutation.error as unknown as ApiError);
    }
    if (unlockUserMutation.error) {
      handleError(unlockUserMutation.error as unknown as ApiError);
    }
  }, [lockUserMutation.error, unlockUserMutation.error, handleError]);

  const handleSubmit = () => {
    if (benefactor.lockedAt) {
      unlockUserMutation.mutate(benefactor.id);
    } else {
      lockUserMutation.mutate(benefactor.id);
    }
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        submitForm={handleSubmit}
        isLoading={lockUserMutation.isPending || unlockUserMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={benefactor.lockedAt ? 'Разрешить вход' : 'Запретить вход'}
        textButtonApply={benefactor.lockedAt ? 'Разрешить' : 'Запретить'}
        textButtonCancel={'Отменить'}
        viewActionButton="outlined-danger">
        <Text variant="body-2" color="secondary">
          {!benefactor.lockedAt
            ? 'Вы уверены, что хотите запретить вход этому пользователю?'
            : 'Вы уверены, что хотите разрешить вход этому пользователю?'}
        </Text>
      </ActionModal>
      <ErrorModal
        open={isErrorModalOpen}
        onClose={handleClose}
        title={errorInfo.title}
        message={errorInfo.message}
      />
    </>
  );
}; 